<!-- Footer -->
<footer id="page-footer" *ngFor="let faculty of facultyData let i=index">

  <section id="footer-content">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <aside class="logo">
            <img src="assets/img/logo-white.png" class="vertical-center">
          </aside>
        </div><!-- /.col-md-3 -->
        <div class="col-md-3 col-sm-4">
          <aside>
            <header><h4>{{faculty.faculty_name}}</h4></header>
            <address>
              <strong>{{faculty.add_line1}}, {{faculty.add_line2}}</strong>
              <br>
              <span>{{faculty.city}}</span>
              <br>
              <span>{{faculty.country}}, {{faculty.postal_code}}</span>
              <br><br>
              <i class="fa fa-phone"></i>&nbsp; {{faculty.phone}}
              <br>
              Ext: &nbsp; {{faculty.extensions}}
              <br><br>
              <i class="fa fa-envelope"></i> &nbsp;<a href="#">{{faculty.email}}</a>
            </address>
          </aside>
        </div><!-- /.col-md-3 -->
        <div class="col-md-3 col-sm-4">
          <aside>
            <header><h4>Links</h4></header>
            <ul class="list-links">
              <li>
                <a routerLink="/allinfo">Faculty Events</a>
              </li>
              <li>
                <a routerLink="/allnews">Latest News</a>
              </li>
              <li>
                <a routerLink="/otherinfo/3">Notices to Students</a>
              </li>
              <li>
                <a routerLink="/otherinfo/4">Vacancies</a>
              </li>
              <li><a href="https://www.lib.ruh.ac.lk/web" target="_blank">Main Libary</a></li>
              <li><a href="#">Research</a></li>
              <li><a href="https://ruh.ac.lk/" target="_blank">University web</a></li>
            </ul>
          </aside>
        </div><!-- /.col-md-3 -->
        <div class="col-md-3 col-sm-4">
          <aside>
            <header><h4>About FoHSS</h4></header>
            <p>The Faculty of Humanities and Social Sciences commenced operating together with the establishment of the Ruhuna University College as an affiliation to the University of Colombo. When the University of Ruhuna appeared as a fully-fledged university, the Faculty of Humanities and Social Sciences underwent a radical change as an academic body.
            </p>
            <div>
              <a routerLink="#" class="read-more">All News</a>
            </div>
          </aside>
        </div><!-- /.col-md-3 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
    <div class="background"><img src="assets/img/background-city.png" class="" alt=""></div>
  </section><!-- /#footer-content -->

  <section id="footer-bottom">
    <div class="container">
      <div class="footer-inner">
        <div class="copyright">Made with <i class="fa fa-heart"></i> by Web Team, IT Unit, Faculty of Humanities & Social Sciences @ 2022 | All rights reserved</div><!-- /.copyright -->
      </div><!-- /.footer-inner -->
    </div><!-- /.container -->
  </section><!-- /#footer-bottom -->
</footer>
<!-- end Footer -->
